import React from 'react';
import { ArrowLeft, AlertCircle, Mail, MapPin, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { logoUrl } from '../mockData';

const Reclami = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-[#1B2380] hover:text-[#0E8C84] transition-colors duration-300"
            >
              <ArrowLeft size={20} />
              <span className="font-medium">Torna alla Home</span>
            </button>
            <img src={logoUrl} alt="Assietica" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <div className="flex items-center space-x-4 mb-8">
            <div className="w-14 h-14 bg-gradient-to-br from-[#E74C3C] to-[#E67E22] rounded-xl flex items-center justify-center">
              <AlertCircle className="text-white" size={28} />
            </div>
            <h1 className="text-3xl sm:text-4xl font-bold text-[#1B2380]">
              Reclami
            </h1>
          </div>

          <p className="text-lg text-gray-700 mb-8 leading-relaxed">
            Eventuali reclami riguardanti il rapporto contrattuale o la gestione dei sinistri 
            devono essere inoltrati per iscritto a:
          </p>

          {/* Ufficio Reclami Box */}
          <div className="bg-[#1B2380]/5 rounded-xl p-8 border border-[#1B2380]/10 mb-8">
            <h2 className="text-xl font-bold text-[#1B2380] mb-6">
              Ufficio Reclami Assietica Soc Coop Società Benefit
            </h2>
            
            <div className="space-y-4">
              {/* Indirizzo */}
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-[#1B2380]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-[#1B2380]" size={20} />
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Indirizzo</p>
                  <p className="text-gray-800 font-medium">
                    Viale Antonio Gramsci, 8/G<br />
                    08015 Macomer (NU)
                  </p>
                </div>
              </div>

              {/* E-mail */}
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-[#0E8C84]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Mail className="text-[#0E8C84]" size={20} />
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">E-mail</p>
                  <a 
                    href="mailto:agenzia@assietica.it" 
                    className="text-[#1B2380] hover:text-[#0E8C84] font-medium transition-colors duration-300"
                  >
                    agenzia@assietica.it
                  </a>
                </div>
              </div>

              {/* PEC */}
              <div className="flex items-start space-x-4">
                <div className="w-10 h-10 bg-[#0E8C84]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <FileText className="text-[#0E8C84]" size={20} />
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">PEC</p>
                  <a 
                    href="mailto:cdsp@pec.confcooperative.it" 
                    className="text-[#1B2380] hover:text-[#0E8C84] font-medium transition-colors duration-300"
                  >
                    cdsp@pec.confcooperative.it
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* IVASS Box */}
          <div className="bg-[#8FE3DA]/10 rounded-xl p-6 border border-[#8FE3DA]/20">
            <h3 className="font-bold text-gray-800 mb-4">Ricorso all'IVASS</h3>
            <p className="text-gray-700 leading-relaxed mb-4">
              Qualora l'esponente non si ritenga soddisfatto dell'esito del reclamo o in caso 
              di assenza di riscontro nel termine massimo di <strong>45 giorni</strong>, potrà rivolgersi a:
            </p>
            <div className="bg-white rounded-lg p-4 border border-[#8FE3DA]/30">
              <p className="font-semibold text-gray-800 mb-2">IVASS - Servizio Vigilanza Intermediari</p>
              <p className="text-gray-700">
                Via del Quirinale, 21<br />
                00187 Roma
              </p>
              <p className="text-gray-700 mt-2">
                <strong>PEC:</strong>{' '}
                <a href="mailto:ivass@pec.ivass.it" className="text-[#1B2380] underline">ivass@pec.ivass.it</a>
              </p>
              <p className="text-gray-700 text-sm mt-3">
                Il reclamo all'IVASS va presentato utilizzando l'apposito <strong>modulo per la presentazione
                dei reclami</strong>, scaricabile dal sito istituzionale, allegando copia del reclamo già
                inoltrato all'intermediario e dell'eventuale riscontro ricevuto.
              </p>
              <a 
                data-testid="ivass-reclami-link"
                href="https://www.ivass.it/consumatori/reclami/index.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block mt-3 text-[#1B2380] hover:text-[#0E8C84] font-medium underline transition-colors duration-300"
              >
                Guida e modulo reclami sul sito IVASS →
              </a>
            </div>
          </div>

          {/* Back button */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <button
              onClick={() => navigate('/')}
              className="bg-gradient-to-r from-[#1B2380] to-[#0E8C84] text-white px-8 py-3 rounded-lg font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300"
            >
              Torna alla Home
            </button>
          </div>
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-[#10154F] text-white py-6 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Assietica Società Cooperativa. Tutti i diritti riservati.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Reclami;
